/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentFundViewModel
 */
export interface InvestmentFundViewModel {
    /**
     * 
     * @type {string}
     * @memberof InvestmentFundViewModel
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFundViewModel
     */
    fundMarketValue: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFundViewModel
     */
    fundPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFundViewModel
     */
    unitPrice: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentFundViewModel
     */
    unitPriceDate: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFundViewModel
     */
    unitsBought: number;
}

/**
 * Check if a given object implements the InvestmentFundViewModel interface.
 */
export function instanceOfInvestmentFundViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;
    isInstance = isInstance && "fundMarketValue" in value;
    isInstance = isInstance && "fundPercentage" in value;
    isInstance = isInstance && "unitPrice" in value;
    isInstance = isInstance && "unitPriceDate" in value;
    isInstance = isInstance && "unitsBought" in value;

    return isInstance;
}

export function InvestmentFundViewModelFromJSON(json: any): InvestmentFundViewModel {
    return InvestmentFundViewModelFromJSONTyped(json, false);
}

export function InvestmentFundViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentFundViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundName': json['FundName'],
        'fundMarketValue': json['FundMarketValue'],
        'fundPercentage': json['FundPercentage'],
        'unitPrice': json['UnitPrice'],
        'unitPriceDate': (new Date(json['UnitPriceDate'])),
        'unitsBought': json['UnitsBought'],
    };
}

export function InvestmentFundViewModelToJSON(value?: InvestmentFundViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundName': value.fundName,
        'FundMarketValue': value.fundMarketValue,
        'FundPercentage': value.fundPercentage,
        'UnitPrice': value.unitPrice,
        'UnitPriceDate': (value.unitPriceDate.toISOString()),
        'UnitsBought': value.unitsBought,
    };
}

